import React from 'react';

const CourtCountController = ({
  currentCount,
  onIncrement,
  onDecrement,
  maxCourts = 10,
  minCourts = 1,
  disabled = false,
  courtAssignments = [],
  availablePlayers = [],
  canDecrement = false,
  decrementReason = null,
  compact = false, // When true: no card wrapper — embeds inline in a controls bar
  hideLabel = false,
}) => {
  const playersNeededForNewCourt = 4;
  const hasEnoughPlayersForNewCourt = availablePlayers.length >= playersNeededForNewCourt;

  const canIncrement =
    currentCount < maxCourts && hasEnoughPlayersForNewCourt && !disabled;

  const canDecrementLocal = currentCount > minCourts && !disabled;
  const finalCanDecrement =
    (canDecrement !== undefined ? canDecrement : canDecrementLocal) &&
    currentCount > minCourts;

  const decrementDisabledReason =
    currentCount <= minCourts
      ? 'Sessions must have at least 1 court'
      : decrementReason || 'Cannot reduce courts';

  const height = compact ? 'h-8' : 'h-10';
  const countText = compact ? 'text-xs' : 'text-sm';
  const minCountWidth = compact ? 'min-w-[2rem]' : 'min-w-[2.5rem]';

  const stepperShell = (
    <div className="inline-flex items-stretch overflow-hidden rounded-lg border border-border-medium bg-surface-subtle shadow-sm">
      <button
        type="button"
        onClick={onDecrement}
        disabled={!finalCanDecrement}
        className={`flex flex-1 items-center justify-center border-0 border-r border-border-medium bg-transparent px-2 text-text-secondary transition-colors
          ${height} ${compact ? 'text-sm' : 'text-base'}
          ${
            finalCanDecrement
              ? 'hover:bg-black/5 hover:text-text-primary dark:hover:bg-white/10'
              : 'cursor-not-allowed opacity-55'
          }`}
        title={!finalCanDecrement ? decrementDisabledReason : 'Remove a court'}
      >
        −
      </button>
      <span
        className={`flex items-center justify-center ${minCountWidth} ${countText} tabular-nums font-semibold text-text-primary`}
        aria-live="polite"
      >
        {currentCount}
      </span>
      <button
        type="button"
        onClick={onIncrement}
        disabled={!canIncrement}
        className={`flex flex-1 items-center justify-center border-0 border-l border-border-medium bg-transparent px-2 text-text-secondary transition-colors
          ${height} ${compact ? 'text-sm' : 'text-base'}
          ${
            canIncrement
              ? 'hover:bg-black/5 hover:text-text-primary dark:hover:bg-white/10'
              : 'cursor-not-allowed opacity-55'
          }`}
        title={
          !canIncrement
            ? !hasEnoughPlayersForNewCourt
              ? `Need ${playersNeededForNewCourt} players to add a court (${availablePlayers.length} available)`
              : 'Maximum courts reached'
            : 'Add a court'
        }
      >
        +
      </button>
    </div>
  );

  const labelEl =
    hideLabel ? null : (
      <span
        className={
          compact ? 'text-xs font-medium text-text-secondary' : 'text-sm font-medium text-text-secondary'
        }
      >
        Courts
      </span>
    );

  if (compact) {
    if (hideLabel) return stepperShell;
    return (
      <div className="flex items-center gap-2">
        {labelEl}
        {stepperShell}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 rounded-lg border border-border-medium bg-surface p-3 shadow-brand-sm sm:p-4">
      {labelEl}
      {stepperShell}
    </div>
  );
};

export default CourtCountController;
